import React from 'react';
import { HiOutlineShoppingBag } from 'react-icons/hi';
import { Link } from 'react-router-dom';

export default function PreBookingPromo() {
    return (
        <section className="relative w-full py-16 px-6 overflow-hidden">
            <div className="max-w-[1200px] mx-auto bg-gradient-to-br from-[#EAF8F5] via-[#FFF5E4] to-[#FCE7EC] rounded-[32px] p-8 sm:p-12 shadow-xl relative overflow-hidden flex flex-col md:flex-row items-center justify-between gap-10 border border-white/60">
                
                {/* Background Decor */}
                <div className="absolute top-0 right-0 w-96 h-96 bg-[#73C8BD] opacity-40 blur-[100px] rounded-full translate-x-1/2 -translate-y-1/2 pointer-events-none" />
                <div className="absolute bottom-0 left-0 w-80 h-80 bg-[#FA8CA6] opacity-30 blur-[100px] rounded-full -translate-x-1/3 translate-y-1/3 pointer-events-none" />
                <div className="absolute top-1/2 left-1/2 w-64 h-64 bg-amber-300 opacity-20 blur-[100px] rounded-full -translate-x-1/2 -translate-y-1/2 pointer-events-none" />

                <div className="relative z-10 max-w-2xl text-left">
                    <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/60 border border-white mb-6 backdrop-blur-md shadow-sm">
                        <span className="flex h-2 w-2 relative">
                            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75"></span>
                            <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-500"></span>
                        </span>
                        <span className="text-xs font-black text-slate-800 uppercase tracking-wider">Now Available Online</span>
                    </div>

                    <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-slate-900 mb-4 leading-tight">
                        Skip the line. <span className="text-transparent bg-clip-text bg-gradient-to-r from-emerald-500 to-[#73C8BD]">Book</span> your kulfis online.
                    </h2>
                    <p className="text-slate-600 font-medium text-lg leading-relaxed mb-8 max-w-xl">
                        Secure your favorite 100% pure milk kulfis before they run out. Add to cart, generate your unique priority token, and pick it up at any Rainbow Truck!
                    </p>

                    <Link to="/products" className="inline-flex h-14 items-center justify-center px-8 bg-[#181F38] hover:bg-slate-800 text-white font-bold rounded-full transition-all shadow-[0_8px_20px_-6px_rgba(24,31,56,0.3)] hover:shadow-[0_12px_24px_-8px_rgba(24,31,56,0.4)] hover:-translate-y-1 gap-3 group">
                        <HiOutlineShoppingBag className="text-xl text-[#73C8BD]" />
                        <span>Buy Now</span>
                        <span className="group-hover:translate-x-1 transition-transform">→</span>
                    </Link>
                </div>

                <div className="relative z-10 w-full max-w-[300px] aspect-square hidden md:flex items-center justify-center">
                     {/* Floating Digital Ticket Graphic */}
                     <div className="absolute w-[240px] h-[320px] bg-white rounded-2xl shadow-2xl rotate-12 animate-float-3d p-4 flex flex-col justify-between border border-slate-100/50 backdrop-blur-sm bg-white/90">
                         <div className="flex items-center justify-between border-b border-dashed border-slate-200 pb-3">
                             <div className="flex items-center gap-2">
                                <span className="w-6 h-6 rounded-full bg-[#EAF8F5] flex items-center justify-center text-[#73C8BD] text-xs font-bold">R</span>
                                <span className="font-bold text-slate-800 text-sm">Book</span>
                             </div>
                             <span className="text-[#73C8BD] text-xs font-bold bg-[#EAF8F5] px-2 py-1 rounded">VIP</span>
                         </div>
                         <div className="flex-1 flex flex-col justify-center items-center py-4 text-center">
                            <h4 className="text-xl font-black text-slate-900">#RB-8X91P</h4>
                            <p className="text-xs text-slate-500 font-medium mt-1">Priority Pickup Token</p>
                            <div className="w-32 h-16 bg-slate-100 mt-4 rounded flex items-center justify-center overflow-hidden relative">
                                {/* Barcode effect */}
                                <div className="absolute inset-0 flex gap-[2px] p-2">
                                    {[...Array(20)].map((_, i) => (
                                        <div key={i} className="h-full bg-slate-800 rounded-sm opacity-80" style={{ width: `${Math.random() * 4 + 1}px` }} />
                                    ))}
                                </div>
                            </div>
                         </div>
                         <div className="text-center pt-2 border-t border-dashed border-slate-200">
                            <span className="text-[10px] font-bold text-slate-400 uppercase tracking-widest">Valid for 24 hours</span>
                         </div>
                     </div>
                </div>

            </div>
        </section>
    );
}
